import { render, staticRenderFns } from "./ExtraFields.vue?vue&type=template&id=143c0228&"
import script from "./ExtraFields.vue?vue&type=script&lang=js&"
export * from "./ExtraFields.vue?vue&type=script&lang=js&"
import style0 from "./ExtraFields.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports